export default class GlobalSharedTools {
  constructor() {
  }

  static isFunction(functionToCheck) {
    var getType = {};
    return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
  }

  static cloneObject(oldObject) {
    return JSON.parse(JSON.stringify(oldObject));
  }
}


// WEBPACK FOOTER //
// ./app/javascript/lib/GlobalSharedTools.js